// src/components/OrganoidChart.js
import { Line } from 'react-chartjs-2';

export function OrganoidChart({ dataBuffer, drugTimestamp, status, bufferSize, experimentStartTime }) {
  const binWidth = 10;
  const roundedMax = Math.ceil((bufferSize) / binWidth) * binWidth; // rounds up to nearest 10s
  const paddedBuffer = dataBuffer.length < bufferSize
    ? [...Array(bufferSize - dataBuffer.length).fill(null), ...dataBuffer]
    : dataBuffer;

  const validBuffer = paddedBuffer
    .filter(d => d && d.timestamp && !isNaN(new Date(d.timestamp)))
    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

  const drugTime = typeof drugTimestamp === 'string'
    ? new Date(drugTimestamp).getTime() / 1000
    : drugTimestamp;

  //const experimentStartTime = validBuffer[0]?.timestamp
  //  ? (Number(validBuffer[0].timestamp) - Number(validBuffer[0].relativeTime)) / 1000
  //  : null;

  console.log(`[DEBUG] drugTimestamp raw:`, drugTimestamp);
  console.log(`[DEBUG] experimentStartTime raw:`, experimentStartTime);
  console.log(`[DEBUG] drugTime (normalized):`, drugTime);

  let drugX = null;

  if (drugTime != null && experimentStartTime != null) {
    drugX = drugTime - experimentStartTime;
    console.log(`[ANNOTATION] Drug line xMin/xMax: ${drugX}`);
  } else {
    console.log("[ANNOTATION] Drug line skipped (missing timestamps)");
  }

  const now = new Date(); // UTC-safe if treated as-is
  const startTime = new Date(now.getTime() - bufferSize * 1000); // 60 seconds ago

  const minTime = Math.min(...validBuffer.map(d => d.relativeTime));
  const maxTime = Math.max(...validBuffer.map(d => d.relativeTime));

  const baseChartOptions = {
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: 'linear', //'time',
        title: { display: true, text: 'Time (seconds)' },
        ticks: {
          source: 'auto',
          autoSkip: true,
          maxRotation: 0,
          callback: val => `${val}`,
          stepSize: binWidth,
          maxTicksLimit: 10,
        },
        min: 0,
        max: roundedMax,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      annotation: {
        annotations: drugTimestamp ? {
          drugLine: {
            type: 'line',
            xMin: drugX, // experimentStartTime ? (drugTimestamp - experimentStartTime) : 0, 
            xMax: drugX, // experimentStartTime ? (drugTimestamp - experimentStartTime) : 0, 
            borderColor: 'blue',
            borderWidth: 2,
            label: {
              content: 'Drug Applied',
              enabled: true,
              position: 'start',
              backgroundColor: 'rgba(0,0,255,0.1)',
              color: 'blue',
              font: {
                weight: 'bold'
              }
            }
          }
        } : {}
      }
    }
  };

  function createChartOptions(label, min, max, drugTimestamp, experimentStartTime) {
    return {
      ...baseChartOptions,
      scales: {
        x: {
        ...baseChartOptions.scales.x,
        max: roundedMax,
        },
        y: {
          beginAtZero: false,
          min,
          suggestedMax: max,
          title: {
            display: true,
            text: label,
          },
        },
      },
      plugins: {
        ...baseChartOptions.plugins,
        annotation: {
          annotations: drugX //drugTimestamp
            ? {
                drugLine: {
                  type: 'line',
                  xMin: drugX, 
                  xMax: drugX, 
                  borderColor: 'blue',
                  borderWidth: 2,
                  label: {
                    content: 'Drug Applied',
                    enabled: true,
                    position: 'start',
                    backgroundColor: 'rgba(0,0,255,0.1)',
                    color: 'blue',
                    font: { weight: 'bold' },
                  },
                },
              }
            : {},
        }
      },
    };
  }

  const chartSpecs = [
    { key: 'temp', label: 'Temperature (°C)', min: 0, max: 40.0, color: 'rgba(255,99,132,1)' },
    { key: 'oxygen', label: 'pO₂ (mmHg)', min: 0, max: 150, color: 'rgba(0,128,0,1)' },
  ];

  return (
    <>
      {chartSpecs.map(({ key, label, min, max, color }) => {
        const data = {
          datasets: [{
            label,
            data: validBuffer.map(d => ({ x: d.relativeTime, y: d[key] })),
            borderColor: color,
            backgroundColor: color.replace('1)', '0.2)'),
            tension: 0.3,
            pointRadius: 0,
          }],
        };

        const options = createChartOptions(label, min, max, drugTimestamp, experimentStartTime);

        return (
          <div key={key} className="chart-section"> { /* style={{ marginBottom: '2rem' }}> */ }
            {/* <h4>{label}</h4> */}
            <div className="chart-bar">
              <Line data={data} options={options} />
            </div>
          </div>
        );
      })}
    </>
  );
}
